import { getGeocode } from "use-places-autocomplete";

import {  STATIC_MAP_BASE_URL,
  STATIC_MAP_FORMAT,
  STATIC_MAP_SCALE,
  STATIC_MAP_SIZE,
  STATIC_MAP_STYLE,
  STATIC_MAP_TYPE,
  STATIC_MAP_ZOOM_LEVEL, } from "../../components/constants/staticMaps";
// import { Address } from "@/ui/types/api/session";

import { Address } from "../../ModalClass/types";

export const getGoogleFormattedAddress = async (
  args: google.maps.GeocoderRequest,
  getShortAddress: boolean = false,
): Promise<{
  address: Address;
  locationType: string;
}> => {
  // TODO: Add improved error handling
  let streetNumber = null,
    route = "",
    city = "",
    state = "",
    postalCode = "",
    subPremise = "",
    locationType = "";

  try {
    const geocodedAddress = await getGeocode(args);
    const { address_components, geometry } = geocodedAddress[0];

    const getComponent = (name: string) => {
      if (getShortAddress)
        return (
          address_components.find(ac => ac.types.includes(name))?.short_name ||
          ""
        );
      return (
        address_components.find(ac => ac.types.includes(name))?.long_name || ""
      );
    };

    streetNumber = address_components.find(ac =>
      ac.types.includes("street_number"),
    );
    route = getComponent("route");
    city = getComponent("locality");
    state =
      address_components.find(ac =>
        ac.types.includes("administrative_area_level_1"),
      )?.short_name || "";
    postalCode =
      address_components.find(ac => ac.types.includes("postal_code"))
        ?.short_name || "";
    subPremise = getComponent("subpremise");
    locationType = geometry.location_type;
  } catch (error) {
    console.error(error);
  }

  const rightStreetName = getShortAddress
    ? streetNumber?.short_name
    : streetNumber?.long_name;
  // Format for UQual
  const formattedAddress: Address = {
    addressLine1: `${rightStreetName ?? ""} ${route}`.trim(),
    addressLine2: subPremise,
    city: city ?? "",
    state: state ?? "",
    postalCode: postalCode ?? "",
  };

  return {
    address: formattedAddress,
    locationType: locationType,
  };
};

export function getStaticMapURL(staticMapAddress: string) {
  staticMapAddress = encodeSpecialCharacters(staticMapAddress);
  const STATIC_MAP_MARKERS = `scale:2|color:0x1D9D77%7C${staticMapAddress}`;
  const STATIC_MAP_FULL_URL = `${STATIC_MAP_BASE_URL}?center=${staticMapAddress}&format=${STATIC_MAP_FORMAT}&zoom=${STATIC_MAP_ZOOM_LEVEL}&size=${STATIC_MAP_SIZE}&scale=${STATIC_MAP_SCALE}&${STATIC_MAP_STYLE}&maptype=${STATIC_MAP_TYPE}&markers=${STATIC_MAP_MARKERS}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
  return STATIC_MAP_FULL_URL;
}

function encodeSpecialCharacters(input: string): string {
  return input.replace(/[#$&+,/:;=?@[\\\]^_`{|}~]/g, match => {
    return "%" + match.charCodeAt(0).toString(16).toUpperCase();
  });
}

export const getGooglePostalCode = (secondaryText: string) => {
  const secondaryTextSplit = secondaryText.split(",");

  return secondaryTextSplit
    .find((_text, index) => index === secondaryTextSplit.length - 2)
    ?.split(" ")?.[2];
};
